import React from 'react';
import styled, { css } from 'styled-components';
import { Button } from '@progress/kendo-react-buttons';

export type ButtonProps = {
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void; // to handle onClick functions
  name?: string; // make the component able to receive children elements
  disabled?: boolean; // make the button disabled or not
  icon?: string;
  wrapperClassName?: string;
  buttonclassName?: string;
  id?: string;
  svgIcon?: React.ReactNode;
};
//Reusable ref component
const ToggleViewButton = React.forwardRef<Button, ButtonProps>(
  (
    {
      name,
      wrapperClassName,
      buttonclassName,
      id,
      disabled,

      svgIcon,

      onClick,
    }: ButtonProps,
    ref,
  ) => {
    return (
      <WrapperDiv className={`${wrapperClassName ?? ''} `} id={id}>
        <Container
          ref={ref} // Forward the ref to the inner button element
          onClick={onClick}
          className={buttonclassName}
          disabled={disabled}
        >
          {svgIcon ?? ''}
        </Container>
      </WrapperDiv>
    );
  },
);

export default ToggleViewButton;
const WrapperDiv = styled.div`
  &.disabled-styles {
    button {
      &:disabled {
        pointer-events: none;
        cursor: not-allowed !important;
      }
    }
  }
  &.form-next-button,
  &.form-prev-button {
    button {
      &:hover {
        background-color: rgb(42 42 42) !important;
      }
    }
  }

  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  button {
    width: 18px;
    min-width: 18px;
    height: 48px;
    padding: 0 0;
    font-size: 12px;
    font-weight: 400;
    box-shadow: none;
    border-radius: 0px 4px 4px 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    cursor: pointer;
    .k-button-text {
      :has(svg) {
        display: flex;
        align-items: center;
      }
    }
    &:disabled {
      cursor: not-allowed;
      opacity: 0.6;
    }
    &:focus {
      box-shadow: none !important;
    }
    &:focus-visible {
      box-shadow: none !important;
    }
  }
`;
export const Container = styled(Button)<ButtonProps>``;
